import { InquiryState, PaymentStatus } from './index';
import { IStore } from '@store/index';
import { GetterTree } from 'vuex';
import { ContactInfo, InquiryContactInfo } from "@store/checkout/interfaces/contactInfo";

export default {
    getTransactionId(state): string {
        return state.dealResponse.transactionId;
    },
    getPaymentStatus(state): PaymentStatus {
        return state.paymentStatus;
    },
    whitelabelConsentValid(state, getter, rootState): boolean {
        let isValid: boolean = true;

        if (rootState.checkout.whitelabelSettings.consent?.required) {
            isValid = state.whitelabelConsent;
        }

        return isValid;
    },
    getWhitelabelConsent(state, getter, rootState): string {
        let consentLabel: string = '';

        if (state.whitelabelConsent) {
            consentLabel = rootState.checkout.whitelabelSettings.consent?.label ?? '';
        }

        return consentLabel;
    },
    isAdditionalFieldValid(state, getter, rootState): boolean {
        return rootState.checkout.whitelabelSettings.additionalField?.required
            ? state.inquiry.additionalCustomerField !== ''
            : true
    },
    isPaymentMethodSelected: (state) => (payment: string) => {
        return state.inquiry.paymentMethod === payment;
    },
    isValidVoucher(state): boolean {
        return state.voucher.isValid;
    },
    isVoucherValidated(state): boolean {
        return state.voucher.isValidated;
    },
    getInquiryContact(state, getter, rootState): InquiryContactInfo {
        // @ts-ignore
        const contactInfo: ContactInfo = rootState.checkout.personalData.contactInfo;
        const phoneWithDialCode = contactInfo.phoneWithDialCode;
        const phone: string = contactInfo.phone;

        return {
            salutation: contactInfo.salutation,
            firstname: contactInfo.firstname,
            lastname: contactInfo.lastname,
            street: contactInfo.street,
            zip: contactInfo.zip,
            city: contactInfo.city,
            country: contactInfo.country,
            phone: phoneWithDialCode ? phoneWithDialCode : phone,
            email: contactInfo.email,
            iso2: contactInfo.iso2
        }
    },
    getBookingId (state): number {
        return state.dealResponse.bookingId;
    },
    getContactEmail (state): string {
        return state.inquiry.contact.email;
    },
    getTourradarBookedPrice (state): number {
        return state.tourradar.thirdPartyInformation?.bookedPrice ?? 0;
    }
} as GetterTree<InquiryState, IStore>
